module.exports = __webpack_public_path__ + "static/media/weight-kilogram.fb65b7e0.svg";